import React, { useState, useEffect, useCallback } from 'react';
import { Dictionary } from 'lodash';
import { AugmentedDevice } from 'shared/models';
import { buildTree, GroupBy, Node, GroupNode, DeviceNode } from './buildTree';
import { useTranslation } from 'react-i18next';
import { DeviceTreeDeviceNode } from './DeviceTreeDeviceNode';
import { DeviceTreeHeader } from './DeviceTreeHeader';
import { DeviceTreeGroupNode } from './DeviceTreeGroupNode';

require('./DeviceTree.css');

export type Props = {
    devices: Dictionary<AugmentedDevice>;
    onClickSchedule(id: string): void;

    // Filtering
    selectedDeviceTypes: Dictionary<boolean>;
    selectedDeviceStatuses: Dictionary<boolean>;
};

export const DeviceTree = ({
    devices,
    onClickSchedule,
    selectedDeviceTypes,
    selectedDeviceStatuses,
}: Props) => {
    const { t } = useTranslation();

    const [ groupBy /* TODO: , setGroupBy*/ ] = useState<GroupBy>('group');
    const [ collapsed, setCollapsed ] = useState<Dictionary<boolean>>({});
    const [ nodes, setNodes ] = useState<Node[]>([]);

    const handleToggleGroup = useCallback((groupId: string) => {
        setCollapsed(collapsed => ({
            ...collapsed,
            [groupId]: !collapsed[groupId],
        }));
    }, [ setCollapsed ]);

    useEffect(() => {
        const nodes = buildTree(devices, groupBy, collapsed, selectedDeviceTypes, selectedDeviceStatuses, t);
        setNodes(nodes);
    }, [ devices, groupBy, collapsed, selectedDeviceTypes, selectedDeviceStatuses, setNodes, t ]);

    return (
        <div id="device-tree">
            <DeviceTreeHeader/>
            { Object.keys(devices).length > 0 && nodes.length === 0 &&
                <div className="no-matching-rows depth-0">
                    { t('DEVICES.FILTERS.NO_MATCHING_ROWS') }
                </div>
            }
            { nodes.map(node => {
                const effectiveId = node.id || 'null';
                return (node as Partial<DeviceNode>).device
                    ? <DeviceTreeDeviceNode
                        key={ effectiveId }
                        { ...node as DeviceNode }
                        id={ effectiveId }
                        onClickSchedule={ onClickSchedule }
                    />
                    : <DeviceTreeGroupNode
                        key={ effectiveId }
                        { ...node as GroupNode }
                        id={ effectiveId }
                        collapsed={ collapsed[effectiveId] }
                        onToggle={ handleToggleGroup }
                    />;
            }) }
        </div>
    );
};
